// Portfolio Site Initialization

import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { SectionTokenClasses } from '../../ModularTypes/SectionSettings';
import type { AssemblyTokenClasses } from '../../ModularTypes/AssemblySettings';
import type { UnitTokenClasses } from '../../ModularTypes/UnitSettings';
import type { MicroUnitTokenClasses } from '../../ModularTypes/MicroUnitSettings';
import type { NanoUnitTokenClasses } from '../../ModularTypes/NanoUnitSettings';

interface LayoutContextProps {
  context: {
    section?: SectionTokenClasses;
    assembly?: AssemblyTokenClasses;
    unit?: UnitTokenClasses;
    microUnit?: MicroUnitTokenClasses;
    nanoUnit?: NanoUnitTokenClasses;
  };
}

// Layout Context Setup
export const LayoutContext = createContext<LayoutContextProps>({
  context: {},
});

interface LayoutProviderProps extends Partial<LayoutContextProps> {
  children: ReactNode;
}

export const useLayout = () => useContext(LayoutContext);

export const LayoutProvider: React.FC<LayoutProviderProps> = ({
  children,

  context = {},
}) => {
  return (
    <LayoutContext.Provider value={{ context }}>
      {children}
    </LayoutContext.Provider>
  );
};
